import { render, staticRenderFns } from "./CadastroTelefonesInput.vue?vue&type=template&id=2f166b30&scoped=true&lang=pug&"
import script from "./CadastroTelefonesInput.vue?vue&type=script&lang=js&"
export * from "./CadastroTelefonesInput.vue?vue&type=script&lang=js&"
import style0 from "./CadastroTelefonesInput.vue?vue&type=style&index=0&id=2f166b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f166b30",
  null
  
)

export default component.exports